<script lang="ts">
  import { Toaster } from 'svelte-sonner';
</script>

<Toaster position="top-center" richColors />

<style>
  :global([data-sonner-toaster]) {
    z-index: 9999999 !important;
  }
</style>